import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyLensOptions } from "src/app/models/company-lens-options.model";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root'
  })
  export class CompanyComputerLensOptionsService extends BaseService {
  
    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'employees/[employee-id]/company-computer-lens-options');
    }

    
  getLensOptions(optionType?: string) {
    let url = `${this.apiUrl}`;
    
    if (optionType) {
      url += `?optionType=${optionType}`;
    }   

    return this.http.get<CompanyLensOptions[]>(url);
  }

}